import { render, staticRenderFns } from "./AllocatedProjectList.vue?vue&type=template&id=79619788&scoped=true&"
import script from "./AllocatedProjectList.vue?vue&type=script&lang=js&"
export * from "./AllocatedProjectList.vue?vue&type=script&lang=js&"
import style0 from "./AllocatedProjectList.vue?vue&type=style&index=0&id=79619788&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79619788",
  null
  
)

export default component.exports